/**
 * SEO component that queries for data with
 *  Gatsby's useStaticQuery React hook
 *
 * See: https://www.gatsbyjs.com/docs/use-static-query/
 */

import * as React from "react";
import PropTypes from "prop-types";
import { useStaticQuery, graphql } from "gatsby";

const Seo = ({
  title,
  description,
  type,
  imgPath,
  publishDate,
  schemaType,
  children,
}) => {
  const { site } = useStaticQuery(
    graphql`
      query {
        site {
          siteMetadata {
            siteUrl
            title
            description
            author {
              name
              summary
            }
            social {
              twitter
            }
            htmlAttributes {
              lang
            }
          }
        }
      }
    `
  );

  const metaDescription = description || site.siteMetadata.description;
  const defaultTitle = site.siteMetadata.title;
  const metaTitle = title || defaultTitle;
  const metaType = type || "website";

  const schema = {
    "@context": "https://schema.org",
    "@type": schemaType || "WebSite",
    name: metaTitle,
    description: metaDescription,
    url: site.siteMetadata.siteUrl,
    publisher: {
      "@type": "Organization",
      name: site.siteMetadata.author.name,
      logo: {
        "@type": "ImageObject",
        url: `${site.siteMetadata.siteUrl}/icon.png`,
      },
    },
    mainEntityOfPage: {
      "@type": "WebPage",
      "@id": site.siteMetadata.siteUrl,
    },
  };
  schema.image = imgPath ? [`${site.siteMetadata.siteUrl}${imgPath}`] : null;

  const schemaAsString = JSON.stringify(schema, null, 2);

  return (
    <>
      <html lang={site.siteMetadata.htmlAttributes.lang} />
      <title>{title ? `${title} | ${defaultTitle}` : defaultTitle}</title>
      <meta name="description" content={metaDescription} />
      <meta property="og:title" content={metaTitle} />
      <meta property="og:description" content={metaDescription} />
      <meta property="og:type" content={metaType} />
      <meta property="og:site_name" content={defaultTitle} />
      {imgPath && (
        <meta
          property="og:image"
          content={`${site.siteMetadata.siteUrl}${imgPath}`}
        />
      )}
      <meta name="twitter:card" content="summary_large_image" />
      <meta
        name="twitter:creator"
        content={site.siteMetadata?.social?.twitter || ``}
      />
      <meta name="twitter:title" content={metaTitle} />
      <meta name="twitter:description" content={metaDescription} />
      <script type="application/ld+json">{schemaAsString}</script>
      <script
        async
        src="https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-2446464916036138"
        crossorigin="anonymous"
      ></script>
      {children}
    </>
  );
};

Seo.defaultProps = {
  meta: [],
  description: ``,
};

Seo.propTypes = {
  description: PropTypes.string,
  meta: PropTypes.arrayOf(PropTypes.object),
  title: PropTypes.string.isRequired,
};

export default Seo;
